import { notifyError } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const getAllSubscription = () => async (dispatch) => {
  dispatch({ type: "SHOW_SUBSCRITION_LOADING" });
  try {
    const { data } = await auction.get("/subscription/read");
    dispatch({ type: "SUBSCRIPTION_VALUE", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "HIDE_SUBSCRIPTION_LOADED" });
  }
};

export const payForSubscription = (id, navigate) => async (dispatch) => {
  dispatch({ type: "SHOW_PAID_SUBSCRITION_LOADING" });
  try {
    const { data } = await auction.put(`/profile/update/subscription/${id}`);
    dispatch({ type: "PAID_SUBSCRIPTION_VALUE", payload: data });
    navigate("/subscription/successful");
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "HIDE_PAID_SUBSCRITION_LOADING" });
  }
};
